import { reactive } from 'vue'

export function useMoveToWorkOrdersDialog (trans) {
  const state = reactive({
    isOpen: false,
    data: null,
    title: trans('road-maintenance/temporary_regulation/requests.sending_to_work_orders'),
    positiveBtnText: trans('base.send'),
    negativeBtnText: trans('base.cancel'),
    showLoader: false,
    onConfirm: null
  })

  const open = ({ data, onConfirm }) => {
    state.isOpen = true
    state.data = data
    state.onConfirm = onConfirm || null
  }

  const close = () => {
    state.isOpen = false
    state.data = null
    state.title = trans('road-maintenance/temporary_regulation/requests.sending_to_work_orders')
    state.positiveBtnText = trans('base.send')
    state.negativeBtnText = trans('base.cancel')
    state.showLoader = false
    state.onConfirm = null
  }

  const setLoader = (value) => {
    state.showLoader = value
  }

  return {
    state,
    open,
    close,
    setLoader
  }
}
